require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/get-iterator.js
// module id = fxRn
// module chunks = 0 64 65 66 67 68 70 71 72 73 74 75 77 89 93 95 96 99